module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Mehinaku")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "pa_1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Contents#pa1"
    }
  }, [_c('span', {
    staticClass: "head01"
  }, [_vm._v("1")])]), _vm._v(" Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "317",
      "src": "images/page_39.jpg",
      "width": "381"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My intention in this book is to describe the way of life of the Mehinaku, a little-known tribe of Indians living in the Mato Grosso of Brazil, by viewing them as performers of social roles.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The first chapter in this introduction examines the validity of the view of life as theater and considers the usefulness and dangers of the dramaturgical metaphor. The second chapter rings up the curtain on the Mehinaku and describes my research among them.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part2#pa_2"
    }
  }, [_vm._v("Part 2")]), _vm._v(", “The Setting for the Drama,” takes the first steps in a dramaturgical analysis of the Mehinaku society by detailing the physical characteristics of the village-theater—how the physical environment, construction materials, house plans, and village layout affect the setting for social relationships. In this section of the book, I examine the village as a theater in the round, one with splendid acoustics and unobstructed seating. The dramaturgical problems and opportunities for the actors are very different from those in our own society with its emphasis on privacy and other barriers to communication. In the Mehinaku village everyday conduct—whether gossip, formal speeches, extramarital affairs or children’s play—is "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("shaped by a spatial setting that compels each individual to become a master of stagecraft and the arts of information control.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In "), _c('span', {
    attrs: {
      "href": "#/xhtml/Part3#part_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("part 3")]), _vm._v(", “The Staging of Social Relationships,” the focus is on the actors and their participation in social engagements. To take part in everyday relationships, the villagers must be adept at make-up, decorating themselves with the body paints and the ornaments that comprise almost all of their wardrobe. Once adorned and ready to engage their fellows, they will follow guidelines that make for orderly interaction, such as the rules for greetings and farewells that circumscribe each social encounter. In the course of interaction all villagers will attempt to project an image of themselves that identifies them as good citizens: cooperative, generous, and sociable. Finally, the continuing drama of Mehinaku social life will be shaped not only by such encounters but also by patterns for avoiding interaction. Villagers who are ambivalent about social situations need defined ways of disengaging themselves from their fellows. The last chapters of part 3 describe the institutions that separate the Mehinaku and allow them to remain aloof from social encounters.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Part4#part_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4")]), _vm._v(", “The Script for Social Life,” examines the roles that the actors perform. Kinsmen and in-laws, tribesmen and foreigners and shamans and clients are the major parts depicted in this final section. As we relate the formal demands of these roles to the theatrical problems involved in staging them, we will also discover that the Mehinaku are not mere puppets manipulated by the demands of their culture but are at times the conscious authors of their own lines.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("In each of the major sections of the book, I have attempted to present Mehinaku culture from a definite theoretical point of view, the analysis of the setting, staging, and script of Mehinaku social life. Without losing sight of this purpose, I occasionally take leave of the dramaturgical metaphor to provide necessary background material and a reasonably full description of a little-known people.")]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_vm._v("Throughout this work I offer translations of Mehinaku words, phrases, and extended passages of speech. Unless otherwise indicated, the translations are free ones, designed to convey the sense of the material rather than its literal meaning. In all direct "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("quotations of speech I have worked from tape recordings or notes taken at or near the time that the passage was spoken. The names of the Mehinaku to whom I attribute these quotes—or who are otherwise mentioned in the book—are usually pseudonyms.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Mehinaku words used in this report are written in a simplified phonetic script adapted for the economics of publication. Consonants have values that approximate English, though the “j” is always soft, as in the “dg” in “judge.”")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Vowels are represented below.")]), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "border": "1",
      "cellpadding": "1",
      "cellspacing": "0"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "no"
  }, [_vm._v("IPA symbol")]), _vm._v(" "), _c('td', {
    staticClass: "no",
    attrs: {
      "colspan": "0"
    }
  }, [_vm._v("Symbol used in text")]), _vm._v(" "), _c('td', {
    staticClass: "no",
    attrs: {
      "colspan": "0"
    }
  }, [_vm._v("Approximate English equivalent")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no"
  }, [_vm._v("a")]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("a")]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("a as in father")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no"
  }, [_vm._v("ε")]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("e")]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("e as in bet")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no"
  }, [_vm._v("i")]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("i")]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("i as in machine")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("I")])]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("I")])]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("i as in bit")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "23",
      "src": "images/pg.jpg",
      "width": "16"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "23",
      "src": "images/pg.jpg",
      "width": "16"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("no English equivalent; a high, central, unrounded vowel")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no"
  }, [_vm._v("O")]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("o")]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("o as in note")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("U")])]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("U")])]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("o as in wolf")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "no"
  }, [_vm._v("u")]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("u")]), _vm._v(" "), _c('td', {
    staticClass: "no"
  }, [_vm._v("u as in rule")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Several Mehinaku dipthongs have rough English equivalents, including "), _c('i', [_vm._v("ai")]), _vm._v(" as in "), _c('i', [_vm._v("ai")]), _vm._v("sle, "), _c('i', [_vm._v("au")]), _vm._v(" as in h"), _c('i', [_vm._v("ou")]), _vm._v("se, and "), _c('i', [_vm._v("ei")]), _vm._v(" as in v"), _c('i', [_vm._v("ei")]), _vm._v("l. A tilde over the vowel indicates a nasalization of the vowel or of the entire dipthong. Unless otherwise indicated, the accent is on the next to last syllable.")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3a534d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Part1.vue
// module id = 78
// module chunks = 0